/** Matches syberkey-service lib/oidc/provider.js supported scopes */
export const OIDC_SCOPE_OPTIONS = ['openid', 'profile', 'email', 'phone', 'address', 'offline_access'];

export function parseScopeFromApi(scopeStr) {
  const parsed = (scopeStr || '').trim().split(/\s+/).filter(Boolean);
  if (parsed.length === 0) return ['openid', 'profile', 'email'];
  return parsed.includes('openid') ? parsed : ['openid', ...parsed];
}

export function scopeMultiSelectOptions(selected) {
  return Array.from(new Set([...OIDC_SCOPE_OPTIONS, ...selected]));
}

export function scopeArrayToApiString(selected) {
  const tokens = Array.isArray(selected) ? [...selected] : [];
  if (!tokens.includes('openid')) tokens.unshift('openid');
  return tokens.join(' ').trim() || 'openid profile email';
}
